import { ApolloClient, InMemoryCache } from "@apollo/client";

export default new ApolloClient({
    uri: process.env.REACT_APP_SERVER_URL,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `Bearer ${localStorage.getItem("did_monitor_token")}`,
    },
});
